import { SpacetimeMode } from 'account-hybrid/core/spacetime-mode.enum';

export type SpacetimeTabName = 'synopsis' | 'portfolio' | 'marketing' | 'curacity' | 'ott' | 'audiences' | 'goals' | 'compare' | 'sfmc';

export interface SpacetimeTabConfig {
    name: SpacetimeTabName;
    label?: string;
}

export interface SpacetimeViewConfig {
    tabs?: SpacetimeTabConfig[];
}

export const SPACETIME_VIEW_CONFIG_BY_MODE: Record<SpacetimeMode, SpacetimeViewConfig> = {
    [SpacetimeMode.Full]: {},
    [SpacetimeMode.SFMC]: {
        tabs: [
            { name: 'sfmc', label: 'SFMC' },
        ],
    },
    [SpacetimeMode.Curacity]: {
        tabs: [
            { name: 'curacity', label: 'Curacity' },
        ],
    },
    [SpacetimeMode.Ott]: {
        tabs: [
            { name: 'ott', label: 'OTT' },
        ],
    },
};

export function getDefaultSpacetimeState(mode: SpacetimeMode): string {
    const firstTab = SPACETIME_VIEW_CONFIG_BY_MODE[mode]?.tabs?.[0]?.name;
    return firstTab ? `spacetime.${firstTab}` : 'spacetime.synopsis';
}

export function isStateAllowedForSpacetimeMode(stateName: string, mode: SpacetimeMode): boolean {
    const config = SPACETIME_VIEW_CONFIG_BY_MODE[mode] || {};
    if (!config.tabs?.length) {
        return stateName === 'spacetime' || stateName.startsWith('spacetime.');
    }
    return config.tabs.some(t => stateName === `spacetime.${t.name}` || stateName.startsWith(`spacetime.${t.name}.`));
}
